/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityReportsDto } from '../../models/facility-reports-dto';

export interface GetFacilityReports$Params {
  facilityId: number;
  authorId?: number;
  fetchAllRecord?: boolean;
  publishedOnly?: boolean;
}

export function getFacilityReports(http: HttpClient, rootUrl: string, params: GetFacilityReports$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityReportsDto>> {
  const rb = new RequestBuilder(rootUrl, getFacilityReports.PATH, 'get');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
    rb.query('authorId', params.authorId, {});
    rb.query('fetchAllRecord', params.fetchAllRecord, {});
    rb.query('publishedOnly', params.publishedOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityReportsDto>;
    })
  );
}

getFacilityReports.PATH = '/api/facility/{facilityId}/facilityreport';
